"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeRSAEncKP = void 0;
const NodeRSA = require('node-rsa');
class NodeRSAEncKP {
    constructor() {
        this.encoder = new TextEncoder();
        this.decoder = new TextDecoder();
    }
    async generateKey(params) {
        this.keyPair = new NodeRSA();
        this.keyPair.setOptions({
            environment: 'browser',
            encryptionScheme: {
                scheme: 'pkcs1_oaep',
                hash: 'sha256',
            }
        });
        this.keyPair.generateKeyPair((params === null || params === void 0 ? void 0 : params.b) || 2048);
        this.publicKeyPEM = this.keyPair.exportKey('pkcs8-public-pem');
        this.privateKeyPEM = this.keyPair.exportKey('pkcs8-private-pem');
    }
    async loadKeyPair(publicKey, privateKey) {
        if (privateKey !== undefined) {
            this.keyPair = new NodeRSA();
            this.keyPair.setOptions({
                environment: 'browser',
                encryptionScheme: {
                    scheme: 'pkcs1_oaep',
                    hash: 'sha256',
                }
            });
            this.keyPair.importKey(privateKey, 'pkcs8-private-pem');
            this.privateKeyPEM = privateKey;
            if (publicKey === undefined) {
                this.publicKeyPEM = this.keyPair.exportKey('pkcs8-public-pem');
            }
            else {
                this.publicKeyPEM = publicKey;
            }
        }
        else if (publicKey !== undefined) {
            this.keyPair = new NodeRSA();
            this.keyPair.setOptions({
                environment: 'browser',
                encryptionScheme: {
                    scheme: 'pkcs1_oaep',
                    hash: 'sha256',
                }
            });
            this.keyPair.importKey(publicKey, 'pkcs8-public-pem');
            this.publicKeyPEM = publicKey;
            this.privateKeyPEM = undefined;
        }
        else {
            throw new Error('Could not import RSA private key using NodeRSA');
        }
    }
    getPublicKey() {
        if (this.publicKeyPEM === undefined) {
            throw new Error('Attempted to export public key, but NodeRSA keypair is uninitialized.');
        }
        return this.publicKeyPEM;
    }
    getPrivateKey() {
        if (this.publicKeyPEM === undefined) {
            throw new Error('Attempted to export private key, but NodeRSA keypair is uninitialized.');
        }
        return this.privateKeyPEM;
    }
    async encrypt(plainText) {
        if (this.keyPair === undefined) {
            throw new Error('Attempted to encrypt, but NodeRSA keypair is uninitialized.');
        }
        return this.keyPair.encrypt(Buffer.from(plainText), 'base64', 'utf8');
    }
    async decrypt(cypherText) {
        if (this.keyPair === undefined) {
            throw new Error('Attempted to decrypt, but NodeRSA keypair is uninitialized.');
        }
        return this.keyPair.decrypt(cypherText, 'utf8');
    }
}
exports.NodeRSAEncKP = NodeRSAEncKP;
//# sourceMappingURL=NodeRSAEncKP.js.map